// extracted by mini-css-extract-plugin
export var locationsContainer = "_z8-2";
export var locationsTextContainer = "_z8-1";
export var mapContainer = "_z8-0";